export const STORAGE_PREFIX = "certa" as const;

/** Keys to preserve during logout (matches legacy behavior) */
export const STORAGE_KEYS_TO_PRESERVE = [
  "taskFilters",
  "recentSearches",
  "preferredLanguage",
  "recentlyViewed"
] as const;
